/**
 * Development-only counts of live heavyweight resources (physics worlds,
 * WebGL renderers), so lifecycle tests can prove that opening, switching and
 * leaving screens releases what it created. Production builds count nothing:
 * every update is behind import.meta.env.DEV and is removed by the bundler.
 */
export interface LiveResourceCounts {
  physicsWorlds: number;
  renderers: number;
}

const counts: LiveResourceCounts = { physicsWorlds: 0, renderers: 0 };

export function countResource(kind: keyof LiveResourceCounts, delta: 1 | -1): void {
  if (import.meta.env.DEV) counts[kind] += delta;
}

export function liveResources(): LiveResourceCounts {
  return { ...counts };
}
